import styled from 'styled-components';
import LogoColor from '@assets/images/colors/logo_colors.svg';
import PrimaryColorGreen from '@assets/images/colors/primary_color_green.svg';
import PrimaryColorWhite from '@assets/images/colors/primary_color_white.svg';
import AgregatorLogo from '@assets/images/logo/agregator_logo.svg';
import PlatformLogo from '@assets/images/logo/platform_logo.svg'; 
import RoomLogo from '@assets/images/logo/room_logo.svg';
import PammLogo from '@assets/images/logo/pamm_logo.svg'; 
import AgregatorColor from '@assets/images/colors/agregator_color.svg';
import PlatformColor from '@assets/images/colors/platform_color.svg'; 
import RoomColor from '@assets/images/colors/room_color.svg';
import PammColor from '@assets/images/colors/pamm_color.svg'; 


export const LogoColorImg = styled(LogoColor)`
`;

export const PrimaryColorWhiteImg = styled(PrimaryColorWhite)`
`;

export const PrimaryColorGreenImg = styled(PrimaryColorGreen)`
`;

export const AgregatorLogoImg = styled(AgregatorLogo)`
`;

export const PlatformLogoImg = styled(PlatformLogo)`
`;

export const RoomLogoImg = styled(RoomLogo)`
`;

export const PammLogoImg = styled(PammLogo)`
`;

export const AgregatorColorImg = styled(AgregatorColor)`
`;

export const PlatformColorImg  = styled(PlatformColor)`
`;

export const RoomColorImg  = styled(RoomColor)`
`;

export const PammColorImg  = styled(PammColor)`
`;
